<template>
<div class="grid mt-1">


<template v-if="brand">
<!---->
<div class="col-12">
<h4 class="text-primary m-0"><b>{{this.$store.state.languages.lang_phrases.marka}}</b></h4>
</div>

<div class="col-12 mb-2"  @click="gotoPage('Brand',{id:brand.id})">
<small class="p-link">{{$filters.sidebartextadjust( brand.name)}}</small>
</div>
<!---->	
</template>	

<template v-if="project">
<!---->
<div class="col-12">
<h4 class="text-primary m-0"><b>{{this.$store.state.languages.lang_phrases.proje}}</b></h4>
</div>

<div class="col-12 mb-2"  @click="gotoPage('Project',{id:project.id})">
<small class="p-link">{{$filters.sidebartextadjust( project.name)}}</small>
</div>
<!---->
</template>

<template v-if="flow">
<!---->
<div class="col-12">
<h4 class="text-primary m-0"><b>{{this.$store.state.languages.lang_phrases.akis}}</b></h4>
</div>

<div class="col-12 mb-2"  @click="gotoPage('Flow',{id:flow.id})">
<small class="p-link">{{$filters.sidebartextadjust( flow.name)}}</small>
</div>
<!---->
</template>

<template v-if="flows">
<!---->
<div class="col-12">
<h4 class="text-primary m-0"><b>{{this.$store.state.languages.lang_phrases.akis}}</b></h4>
</div>

<div class="col-12 mb-2"  v-for="flow in flows" @click="gotoPage('Flow',{id:flow.id})" >
<small class="p-link">{{$filters.sidebartextadjust( flow.name)}}</small>
</div>
<!---->
</template>

<template v-if="questionlist">
<!---->
<div class="col-12">
<h4 class="text-primary m-0"><b>{{this.$store.state.languages.lang_phrases.soru_listesi}}</b></h4>
</div>

<div class="col-12 mb-2"  @click="gotoPage('Questionlist',{id:questionlist.id})">
<small class="p-link">{{$filters.sidebartextadjust( questionlist.name)}}</small>
</div>
<!---->
</template>

<template v-if="educationpack">
<!---->
<div class="col-12">
<h4 class="text-primary m-0"><b>{{this.$store.state.languages.lang_phrases.egitim_paketleri}}</b></h4>
</div>

<div class="col-12 mb-2"  @click="gotoPage('Educationpack',{id:educationpack.id})">
<small class="p-link">{{$filters.sidebartextadjust( educationpack.name)}}</small>
</div>
<!---->
</template>


<template v-if="brand || flow || questionlist || project || section">
 <div class="col-12"><hr></div>
</template>

<div class="col-12">
<div class="grid">

<div class="col" v-if="is_active">
<h3 class="text-center text-red-500 mt-0 mb-1 font-medium  border-2 border-solid border-round-sm" v-if="is_active=='deactive'">{{$store.state.languages.lang_phrases.deaktif}}</h3>
<h3 class="text-center text-green-500 mt-0 mb-1 font-medium  border-2 border-solid border-round-sm" v-else>{{$store.state.languages.lang_phrases.aktif}}</h3>
</div>


<div class="col" v-if="sectioncount">
<h1 class="text-center text-primary mt-0 mb-1 font-medium">{{sectioncount}}</h1>
<p class="text-bluegray-400 text-center mt-0 mb-1">{{$store.state.languages.lang_phrases.bolum}}</p>
</div>

<div class="col" v-if="questioncount">
<h1 class="text-center text-primary mt-0 mb-1 font-medium">{{questioncount}}</h1>
<p class="text-bluegray-400 text-center mt-0 mb-1">{{$store.state.languages.lang_phrases.soru}}</p>
</div>


<div class="col" v-if="suppliercount">
<h1 class="text-center text-primary mt-0 mb-1 font-medium">{{suppliercount}}</h1>
<p class="text-bluegray-400 text-center mt-0 mb-1">{{$store.state.languages.lang_phrases.tedarikci}}</p>
</div>

<div class="col" v-if="projectcount">
<h1 class="text-center text-primary mt-0 mb-1 font-medium">{{projectcount}}</h1>
<p class="text-bluegray-400 text-center mt-0 mb-1">{{$store.state.languages.lang_phrases.proje}}</p>
</div>

<div class="col" v-if="flowcount">
<h1 class="text-center text-primary mt-0 mb-1 font-medium">{{flowcount}}</h1>
<p class="text-bluegray-400 text-center mt-0 mb-1">{{$store.state.languages.lang_phrases.akis}}</p>
</div>

<div class="col" v-if="awaitingcount">
<h1 class="text-center text-primary mt-0 mb-1 font-medium">{{awaitingcount}}</h1>
<p class="text-bluegray-400 text-center mt-0 mb-1">{{$store.state.languages.lang_phrases.bekleyen}}</p>
</div>

<div class="col" v-if="finishedcount">
<h1 class="text-center text-primary mt-0 mb-1 font-medium">{{finishedcount}}</h1>
<p class="text-bluegray-400 text-center mt-0 mb-1">{{$store.state.languages.lang_phrases.tamamlanan}}</p>
</div>










</div>
</div>


</div>

</template>

<script>
export default {
  props:["brand","project","flow","flows","questionlist","educationpack","section","questioncount","sectioncount","suppliercount","projectcount","flowcount","finishedcount","awaitingcount","is_active"],
  name: 'ItemSidebarContent',

  data () {
    return {

    }
  },
  mounted()
  {
  },
}
</script>

<style lang="css" scoped>
</style>